import type { ReactNode } from 'react';

export const symbol_add_diamond: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-449v96q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-96h97q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5h-97v-97q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v97h-96q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h96Zm30 369q-11 0-22-4.5T438-97L98-437q-8-9-12.5-20T81-479q0-11 4.5-22.5T98-521l340-341q9-9 20-13t22.5-4q11.5 0 22.5 4t19 13l341 341q9 8 13 19.5t4 22.5q0 11-4 22t-13 20L522-97q-8.11 8.13-19.16 12.57Q491.79-80 480-80Zm0-60 340-339-340-340-339 340 339 339Zm1-340Z"
		/>
	</svg>
);
